module.exports = __webpack_public_path__ + "static/img/wyy.5879df4d.jpg";